var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Equipo Serie" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("InfromacioRequerimientoForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pasoActivoIndex === _vm.pasos.requerimiento.step,
                expression: "pasoActivoIndex === pasos.requerimiento.step"
              }
            ],
            attrs: {
              modoVer: true,
              isVerDetalle: true,
              modoEditar: false,
              reporte_Seleccionado: _vm.reporte_Seleccionado,
              readonly: true
            }
          }),
          _c("SerieNumeroForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pasoActivoIndex === _vm.pasos.serie_numero.step,
                expression: "pasoActivoIndex === pasos.serie_numero.step"
              }
            ],
            attrs: {
              modoVer: true,
              serieNumeroSeleccionado: _vm.serieNumeroSeleccionado,
              tipoEquipoSeleccionado: _vm.tipoEquipoSeleccionado,
              serieactivanroSeleccionado: _vm.serieactivanroSeleccionado,
              isVerDetalle: true
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }